import React from 'react';

type GuideType = 'default' | 'small';

export interface GuideProps {
  type?: GuideType;
  to?: string;
  https?: string;
  screen?: string;
}

const Guide = ({
  to = 'https://buildmystory.com/guide/',
  https: className = '',
  type = 'default',
  screen = '',
}: GuideProps) => {
  return (
    <div className={`flex items-center ml-2 ${className}`}>
      {type === 'default' && (
        <div className={`relative h-[30px] md:h-[30px] rounded-full `}>
          <a href="https://buildmystory.com/guide/" target="_blank" rel="noopener noreferrer">
            <img className="h-[30px]  w-[30px]" src="/help.png" alt="Build My Story Guide" title="Guide" />
          </a>
        </div>
      )}
      {type === 'small' && (
        <div className={`relative h-[30px] md:h-[30px] rounded-full `}>
          <a href="https://buildmystory.com/guide/" target="_blank" rel="noopener noreferrer">
            <img
              className="h-[30px] w-[30px]"
              src="/small-question-icon.svg"
              alt="Build My Story Guide"
              title="Guide"
            />
          </a>
        </div>
      )}
      {/* </Link> */}
    </div>
  );
};

export default Guide;
